import React from 'react'

import { TASK_INCLUDE_FIELD_LIMIT } from '@SonarCX/providers/TaskPageStateProvider'
import { isUUID } from '@SonarCX/utilities'
import { arrayToQuery } from '@SonarCX/lib/api'
import useTaskColumnSettings from '@SonarCX/hooks/useTaskColumnSettings'

type UseTaskIncludesOptions = {
  key: string
  includeAnd?: boolean
}

const useTaskIncludes = ({
  key,
  includeAnd = true
}: UseTaskIncludesOptions) => {
  const { columnVisible } = useTaskColumnSettings(key)

  const includedFields = React.useMemo(() => {
    const fields = columnVisible.filter(id => isUUID(id))
    return fields.slice(0, TASK_INCLUDE_FIELD_LIMIT)
  }, [columnVisible])

  const asQuery = React.useMemo(() => {
    const query = arrayToQuery('include_custom', includedFields)

    if (!query) {
      return ''
    }

    if (!includeAnd) {
      return query
    }

    return `&${query}`
  }, [includedFields, includeAnd])

  return asQuery
}

export default useTaskIncludes
